import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";

export default function Login() {
  const { session, loading, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && session) {
      navigate("/", { replace: true });
    }
  }, [session, loading, navigate]);

  if (loading) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        style={{ background: "var(--canvas)" }}
      >
        <div style={{ fontSize: 13, color: "var(--ink-faint)" }}>Loading…</div>
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center p-6"
      style={{ background: "var(--canvas)" }}
    >
      <div className="w-full max-w-sm">
        {/* Brand */}
        <div className="text-center" style={{ marginBottom: 40 }}>
          <h1
            style={{
              fontFamily: "'Source Serif 4', Georgia, serif",
              fontWeight: 600,
              fontSize: 36,
              letterSpacing: "-0.02em",
              color: "var(--ink)",
            }}
          >
            Zedule<span style={{ color: "var(--accent)" }}>.</span>
          </h1>
          <p
            style={{
              marginTop: 6,
              fontFamily: "'JetBrains Mono', ui-monospace, monospace",
              fontSize: 10.5,
              fontWeight: 500,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "var(--ink-faint)",
            }}
          >
            Business dashboard
          </p>
        </div>

        {/* Card */}
        <div
          style={{
            background: "var(--paper-raised)",
            borderRadius: 14,
            padding: 36,
            boxShadow: "var(--shadow-sm)",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontFamily: "'Source Serif 4', Georgia, serif",
              fontWeight: 500,
              fontSize: 24,
              letterSpacing: "-0.014em",
              color: "var(--ink)",
            }}
          >
            Welcome back.
          </h2>
          <p
            style={{
              marginTop: 10,
              marginBottom: 24,
              fontSize: 14,
              lineHeight: 1.55,
              color: "var(--ink-soft)",
              maxWidth: "30ch",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Sign in to manage appointments, services, and the people who run your day.
          </p>
          <button
            onClick={signInWithGoogle}
            style={{
              width: "100%",
              height: 44,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              padding: "0 16px",
              borderRadius: 12,
              background: "var(--ink)",
              color: "var(--canvas)",
              border: "none",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              boxShadow: "var(--shadow-cta)",
              transition: "transform 120ms ease",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
          >
            <svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <g fill="none" fillRule="evenodd">
                <path d="M17.64 9.205c0-.638-.057-1.252-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853" />
                <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05" />
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335" />
              </g>
            </svg>
            Sign in with Google
          </button>
        </div>

        <p
          style={{
            marginTop: 20,
            textAlign: "center",
            fontSize: 12,
            color: "var(--ink-faint)",
          }}
        >
          Only authorized business owners and staff can access this dashboard.
        </p>
      </div>
    </div>
  );
}
